import { OFFICIAL_URL } from '@cores/constants/envConfig';
export const REGION_LIST = ['CN', 'US', 'EU'];
// patsnap数据导入文件大小限制
export const IMPORT_FILE_SIZE_LIMIT_FOR_PATSNAP = 8 * 1024 * 1024; // 8MB
// 第三方数据导入文件大小限制
export const IMPORT_FILE_SIZE_LIMIT_FOR_THIRD_PARTY = 20 * 1024 * 1024; // 20MB
export const HELPER_CENTER_LINK_CN = {
    AI_TAGGING: 'https://help.zhihuiya.com/help/15430887249561/article/25312512061209?categoryId=15429297885337',
    CUSTOM_FIELD: 'https://help.zhihuiya.com/help/15430887249561/article/15432990304409?categoryId=15429297885337',
    EMPTY_DATA: 'https://help.zhihuiya.com/help/15430887249561/article/15630344326937?categoryId=15429297885337',
    SPACE_TRANSFER: 'https://help.zhihuiya.com/help/15430887249561/article/15432789536281?categoryId=15429297885337',
    COMPANY_SPACE: 'https://help.zhihuiya.com/help/15430887249561/article/15432789536281?categoryId=15429297885337',
    SPACE_SHARE: 'https://help.zhihuiya.com/help/15430887249561/article/17735919675545?categoryId=15429297885337',
};
export const HELPER_CENTER_LINK_US = {
    AI_TAGGING: 'https://help.patsnap.com/hc/en-us/articles/4416660932241-What-Is-AI-Custom-Field-Tagging-and-How-Do-I-Use-It-',
    CUSTOM_FIELD: 'https://help.patsnap.com/hc/en-us/articles/207745039-What-are-custom-fields-',
    EMPTY_DATA: 'https://help.patsnap.com/hc/en-us/articles/8363330376477',
    SPACE_TRANSFER: 'https://help.patsnap.com/hc/en-us/articles/360020409137-How-Can-I-Transfer-Ownership-of-Workspaces-',
    COMPANY_SPACE: 'https://help.patsnap.com/hc/en-us/articles/360018589298-How-Can-I-Create-A-Company-Workspace-',
    SPACE_SHARE: 'https://help.patsnap.com/hc/en-us/articles/10919769865885-Workspace-Sharing-Permissions',
};
export const REQUEST_DEMO_LINK_TEMPLATE_MAP = {
    CN: `${OFFICIAL_URL}/orders/?email={{ email }}&indus=workspace&client=Analytics`,
    US: `${OFFICIAL_URL}/request-a-demo?utm_campaign=InApp Feature Demo Request&utm_source=PatSnap&utm_medium=Application&email={{ email }}&firstname=&lastname=&company={{ company }}&module_demo_requested={{ project }}`,
};
export const SYNAPSE_HIDDEN_KEY_MAP = {
    CN: [],
    US: ['HIGHEST_DEV_STATUS_CN'],
};
